module.exports = __webpack_public_path__ + "img/abu2.d500e114.png";